import AsyncStorage from '@react-native-async-storage/async-storage';
import { clearAuthSession } from './AuthSession';

const signOut = async () => {
  await clearAuthSession();
  await AsyncStorage.clear().catch(() => undefined);
};

export default signOut;
